<template>
    <IOdometer class="iOdometer" :value="num" :styles="styles" format="(.ddd),dd"/>
</template>
  
<script>
import IOdometer from 'vue-odometer';
import 'odometer/themes/odometer-theme-default.css';
export default {
    name: "NumberOdometer",
    props: {
        final: {
            type: Number,
            default: 1
        },
        duration: {
            type: Number,
            default: 6000
        },
        initial: {
            type: Number,
            default: 0
        },
        styles: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        IOdometer
    },
    data() {
        return {
            num: this.initial,
            intervalNum: null
        }
    },
    mounted() {
        const that = this;
        this.intervalNum = setInterval(function () {
            if (that.final>=1000 && that.final-that.num>=5) {
                that.num += 5;
            }else{
                that.num += 1;
            }
        }, this.calculeTime);        
    },
    watch: {
        num() {
            if (this.num === this.final) {
                clearInterval(this.intervalNum);
            }
        }
    },
    computed: {
        calculeTime() {
            return this.duration / (this.final - this.initial);
        }
    }

}
</script>